import { UPDATE_FRONT_STYLE_PMR } from "./frontStylePmrReducer"

export const updateFrontStylePmr = (status) => ({
    type: UPDATE_FRONT_STYLE_PMR,
    payload: status
})
